
let spacings = {
    small: 8,
    medium: 16,
    thick: 20,
    large: 32
};

export = spacings;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/material-ui/spacings.ts
 **/